import React from 'react';

import ItemViewTop from "../../../../../../layout/top/item-view-top/item-view-top";
import ErrorBoundary from "../../../../../error-boundary";
import {EntityType} from "../../../../../gd/const/item";
import {getTaskCustomFieldByType} from "../../../../../fields/custom-field-factory";
import FieldManagementFormCFV1 from "../../../../../fields3/render/management-form-cf-v1";
import {ModalCustomFieldParams} from "../../modal";


type Props = {
    type        : number
    params      : ModalCustomFieldParams,
    isNew       : boolean

    onBackToStep1   : callback
    onCloseClick    : callback
    onSubmit        : callback

}

// const debug = "ModalCustomField_Step2Form"
const debug = false

export default class ModalCustomField_Step2Form extends React.Component<Props> {

    onClick = (e:React.SyntheticEvent) => {
        e.stopPropagation();
        e.preventDefault();
    }

    render() {

        debug && console.log(debug,"render", this.props.type, this.props.params)

        const params    = _.clone(this.props.params);

        const field     = getTaskCustomFieldByType(this.props.type, this.props.params.customField);

        const FieldForm = field.FormAddComponent;

        // patch
        if (field.version === 3) {
            if (field.isNewField) {
                field.fieldParams.scope = this.props.params.scope //this.props.params.mandatoryScope
            }
        }

        debug && console.log(debug,"render field", field)


        const topLeftContent = this.props.isNew ?
            <div className="ui5-link-icon-default" onClick={this.props.onBackToStep1}>
                <div className="icon i5-long-arrow-left"/>
                Select type
            </div>
            :
            <div className="ui5-txt-not-important-small">Edit custom field</div>

        return (
            <div className="v4-container placement-middle ui5-iv view-custom-field" style={{width: 840}} onClick={this.onClick}>
                <ItemViewTop leftContent={topLeftContent} onCloseClick={this.props.onCloseClick}/>

                <ErrorBoundary>

                    {field.version === 1 &&
                        <FieldForm {...params} onSubmit={this.props.onSubmit}/>
                    }

                    {field.version === 3 &&
                        <FieldManagementFormCFV1 field          = {field}
                                                 isNewField     = {true}
                                                 scope          = {this.props.params.scope}
                                                 mandatoryScope = {this.props.params.mandatoryScope}
                                                 entity         = {EntityType.TASK}
                                                 onSubmit       = {this.props.onSubmit} />
                    }

                </ErrorBoundary>
            </div>
        )
    }
}
